import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import ColorPickerListItem from '../../../../../list-items/ColorPickerListItem';
import { HexToRgb } from '../../../../../../utilities/colorUtilities';

const TextColorListItem = (props) => {
    const { textElementColor, index, updateTextElement } = props;
    let color = HexToRgb(textElementColor);

    const onColorChange = (color) => updateTextElement(index, { color: color.hex.replace('#', '0x') });

    return (
        <ColorPickerListItem
            text='Color'
            color={color}
            disableAlpha={true}
            onChange={onColorChange}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const { color: textElementColor } = state.createPreview.present.videoSettings.text.textElements[ownProps.index];
    return { textElementColor };
}

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextColorListItem);